import { createContext, useEffect, useState } from "react";

export const AcademicReportContentContext = createContext();

const initialReportContentState = {
  admissions: "",
};

export const ADMISSIONS = "admissions";

export const AcademicReportContentContextProvider = ({ children }) => {
  const [content, setContent] = useState(initialReportContentState);

  const setSubTitle = (subTitle, subTitleContent) => {
    setContent((content) => {
      const newContent = {
        ...content,
      };
      newContent[subTitle] = subTitleContent;
      return newContent;
    });
  };

  const getSubTitle = (subTitle) => {
    return content[subTitle];
  };

  useEffect(() => {
    // Get the content from the backend and use setContent to set the same
    console.log(content);
  }, [content]);

  return (
    <AcademicReportContentContext.Provider
      value={{ content, setContent, setSubTitle, getSubTitle }}
    >
      {children}
    </AcademicReportContentContext.Provider>
  );
};
